<template>
  <!-- ======================= -->
  <!-- TAB: HEALING            -->
  <!-- ======================= -->
  <div>
    <!-- ----------------- -->
    <!--   HEALING DETAILS -->
    <!-- ----------------- -->
    <div class="row mt-2 mb-2"></div>
    <p class="bb-hdg mt-2 mb-3">Healing Details</p>
    <!-- ---------- -->
    <!--    ROW 1   -->
    <!-- ---------- -->
    <div class="row mt-2 mb-2">
      <!-- -------------- -->
      <!--  healing type  -->
      <!-- -------------- -->
      <div class="col-4 form-group">
        <div class="form-floating">
          <v-select
            v-if="isNewItem"
            :options="healingTypeOptions"
            :class="[
              'form-control',
              { 'is-invalid': errorFields.includes('healing_type') },
            ]"
            placeholder="select..."
            :modelValue="localItem.healing_type"
            @update:modelValue="onFieldChanged('healing_type', $event)"
            id="healing_type"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
          <input
            v-else
            readonly
            class="form-control text-center"
            :value="activeItem.healing_type"
            id="healing_type"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="healing_type"
            >Healing Type</label
          >
        </div>
      </div>
    </div>
    <!-- ---------- -->
    <!--    ROW 2   -->
    <!-- ---------- -->
    <div class="row mt-2 mb-2">
      <!-- ------------ -->
      <!--   recovers   -->
      <!-- ------------ -->
      <div class="col form-group">
        <div class="form-floating">
          <input
            v-if="isNewItem"
            :class="[
              'form-control text-left',
              { 'is-invalid': errorFields.includes('recovers') },
            ]"
            :value="localItem.recovers ?? activeItem.recovers"
            id="recovers"
            @input="onFieldChanged('recovers', $event.target.value)"
          />
          <input
            v-else
            readonly
            class="form-control text-left"
            :value="activeItem.recovers"
            id="recovers"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="recovers"
            >Recovers</label
          >
        </div>
      </div>
    </div>
    <!-- ---------- -->
    <!--    ROW 3   -->
    <!-- ---------- -->
    <div class="row mt-2 mb-2">
      <!-- ----------- -->
      <!--    delay    -->
      <!-- ----------- -->
      <div class="col form-group">
        <div class="form-floating">
          <input
            v-if="isNewItem"
            :class="[
              'form-control text-left',
              { 'is-invalid': errorFields.includes('delay') },
            ]"
            :value="localItem.delay ?? activeItem.delay"
            id="delay"
            @input="onFieldChanged('delay', $event.target.value)"
          />
          <input
            v-else
            readonly
            class="form-control text-left"
            :value="activeItem.delay"
            id="delay"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="delay"
            >Delay</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArtefactHealingTab',
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    localItem: {
      type: Object,
      required: true,
    },
    isNewItem: {
      type: Boolean,
      default: false,
    },
    onFieldChanged: {
      type: Function,
      default: () => {},
    },
    healingTypes: {
      type: Array,
      default: () => [],
    },
    errorFields: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    healingTypeOptions() {
      return this.healingTypes
    },
  },
}
</script>
